<template>
  <div class="doctor-panel wrapper" ref="panel">
    <div class="scroller">
      <div class="patient-card p-3 bg-white">
        <PatientCard :patient.sync="patient.clinic_patient"></PatientCard>
      </div>
      <nav class="nav nav-pills nav-fill mb-3 mx-3">
        <a
          class="nav-item nav-link"
          :class="{ active: current === 'schedule' }"
          @click.prevent="current = 'schedule'"
          href="#"
        >
          {{ $t("schedule") }}
        </a>
        <a
          class="nav-item nav-link"
          :class="{ active: current === 'history' }"
          @click.prevent="current = 'history'"
          href="#"
        >
          {{ $t("history") }}
        </a>
      </nav>
      <transition name="slideNext">
        <template v-if="current === 'history'">
          <PatientHistory :patient.sync="patient.clinic_patient"></PatientHistory>
        </template>
        <template v-else-if="current === 'schedule'">
          <PatientSchedule :patient-id.sync="patient.clinic_patient.id" :change-tab="changeTab"></PatientSchedule>
        </template>
      </transition>
    </div>
  </div>
</template>
<script>
import PatientHistory from '@/components/Panel/CaseManager/PatientHistory'
import PatientCard from '@/components/Panel/CaseManager/PatientCard'
import PatientSchedule from '@/components/Panel/CaseManager/PatientSchedule'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    PatientHistory,
    PatientCard,
    PatientSchedule
  },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      current: 'schedule'
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      headHeight: 'head/height',
      windowHeight: 'app/height'
    })
  },
  watch: {
    headHeight (val) {
      this.$refs.panel.style.height = `${this.windowHeight - val}px`
    },
    windowHeight (val) {
      this.$refs.panel.style.height = `${val - this.headHeight}px`
    },
    patient: {
      deep: true,
      immediate: true,
      handler (val) {
        for (const schedule of val.schedules) {
          this.setSchedule(schedule)
        }
      }
    }
  },
  mounted () {
    this.$refs.panel.style.height = `${window.innerHeight - this.headHeight}px`
  },
  methods: {
    ...mapMutations({
      setSchedule: 'schedule/set'
    }),
    changeTab (tab) {
      this.current = tab
    }
  }
}
</script>
<style lang="scss">
.doctor-panel {
  .nav {
    .nav-item {
      transition: all 0.2s linear;
      &.active {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        position: relative;
        &::after {
          transition: all 0.2s linear;
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #3c88ff;
          clear: both;
        }
      }
    }
  }
  .patient-card {
    z-index: 200;
    // position: sticky;
    // top: 0;
  }
  // .history {
  //   box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  // }
  &.wrapper {
    .scroller {
      height: calc(100%);
      overflow: auto;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "history": "ქეისები",
      "schedule": "ვიზიტები"
  }
}
</i18n>
